import React, { useState } from "react";
import Editor from "@monaco-editor/react";

const getLineColumn = (text, pos) => {
  const lines = text.slice(0, pos).split("\n");
  const line = lines.length;
  const column = lines[lines.length - 1].length + 1;
  return { line, column };
};

const JsonEditor = ({ setErrorDetails, darkMode, editorRef }) => {
  const [value, setValue] = useState('{ "key": "value"}');

  const handleEditorChange = (val) => {
    const text = val || "";
    setValue(text);

    try {
      JSON.parse(text);
      setErrorDetails({ valid: true });
    } catch (err1) {
      try {
        const unescaped = text.replace(/\\"/g, '"');
        JSON.parse(unescaped);
        setErrorDetails({
          valid: true,
          message: "✅ Valid compressed JSON string",
        });
      } catch (err2) {
        const match = err2.message.match(/at position (\d+)/);
        const pos = match ? parseInt(match[1], 10) : -1;
        const { line, column } = pos !== -1 ? getLineColumn(text, pos) : { line: "?", column: "?" };

        setErrorDetails({
          valid: false,
          message: `${err2.message} (line ${line}, column ${column})`,
        });
      }
    }
  };

  const handleEditorMount = (editor) => {
    editorRef.current = editor;
    
    // Monaco editor already handles Ctrl+A natively - no need to override
    // Removing custom handler to allow default copy/cut/paste behavior
  };

  return (
    <Editor
      height="100%"
      language="json"
      value={value}
      theme={darkMode ? "vs-dark" : "light"}
      onChange={handleEditorChange}
      onMount={handleEditorMount}
      options={{
        minimap: { enabled: false },
        fontSize: 14,
        automaticLayout: true,
        scrollBeyondLastLine: false,
        wordWrap: "on",
        lineNumbers: "on",
        folding: true,
        bracketPairColorization: {
          enabled: true,
        },
        suggest: {
          enabled: true,
        },
        quickSuggestions: true,
        formatOnPaste: true,
        formatOnType: true,
      }}
    />
  );
};

export default JsonEditor;
